import { Navigate, useLocation } from 'react-router-dom'
import { useCurrentUser } from '@/api/hooks'

type Props = {
  children: React.ReactNode
  adminOnly?: boolean
}

export function RequireAuth({ children, adminOnly = false }: Props) {
  const { data: user, isLoading, isFetching } = useCurrentUser()
  const location = useLocation()

  if (isLoading || (isFetching && !user)) return null
  if (!user) {
    const redirect = encodeURIComponent(location.pathname + location.search)
    return <Navigate to={`/login?redirect=${redirect}`} replace />
  }
  if (adminOnly && !user.isAdmin) return <Navigate to="/shows" replace />
  return <>{children}</>
}

export default RequireAuth
